import axios from '~/utils/axiosInstance';

export const getInvestorDashboardOverview = async () => {
  const response = await axios.get('/dashboard/investor-overview');
  return response.data;
};

export const getCumulativeMatchesOverTime = async () => {
  const response = await axios.get('/dashboard/cumulative-matches-over-time');
  return response.data;
};